import { UserLevel } from 'server/types';
import { hasLevel } from 'shared/auth';
import { MAX_STUDENT_FILESIZE } from 'shared/consts';
import { formatBytes } from 'shared/formatting';
import { isVideo } from 'shared/media';

export function knownMaxUploadSize(user: { level: UserLevel } | undefined) {
  if (!user || hasLevel(user, 'guide')) {
    return;
  }
  return MAX_STUDENT_FILESIZE;
}

export function isOverUploadLimit(file: { size: number }, maxSize: number | undefined) {
  return maxSize !== undefined && file.size > maxSize;
}

export function oversizeMessage(file: { name: string; type: string }, maxSize: number) {
  const message = `${file.name} is over the ${formatBytes(maxSize)} limit.`;
  if (isVideo(file.type)) {
    return `${message} Trim the video, or post a link to it instead.`;
  }
  return message;
}
